export function findPath(types, id) {
    function findNode(path, node) {
        if (node.id === id) return [...path, node];
        const children = node.children;
        if (!children?.length) return null;
        for (let index = 0; index < children.length; index++) {
            const result = findNode([...path, node], children[index]);
            if (result) return result;
        }
    }
    for (let index = 0; index < types.length; index++) {
        const result = findNode([], types[index]);
        if (result) return result;
    }
}

export function findType(types, id) {
    function findNode(node) {
        if (node.id === id) return node;
        const children = node.children;
        if (!children?.length) return null;
        for (let index = 0; index < children.length; index++) {
            const result = findNode(children[index]);
            if (result) return result;
        }
    }
    for (let index = 0; index < types.length; index++) {
        const result = findNode(types[index]);
        if (result) return result;
    }
}
